import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import darkVideo from '@/assets/MMA_illu_production animation_dark.mp4'
import greyVideo from '@/assets/MMA_illu_production animation_grey.mp4'
import { useStartupSteps } from '@/hooks/useStartupSteps'
import { RootState } from '@/utils/store/store'

import StartupScreen from './StartupScreen'

import './StartupGate.scss'

/**
 * The splash over the whole app while a user signs in: one screen from the sign-in (which leaves the page and comes
 * back) until the first space is there. A user who is signed in already does not see it, it is not shown again after
 * the first time, and not while the login page waits for the user to press its button.
 */
const StartupGate = () => {
    const { t } = useTranslation()
    const { steps, allDone, waitingForUser, signingIn } = useStartupSteps()
    const isDarkTheme = useSelector((state: RootState) => state.application.darkTheme)
    const [finished, setFinished] = useState(false)
    // Starts with the sign-in, and stays until everything is done (the sign-in is done before the spaces are)
    const [engaged, setEngaged] = useState(() => sessionStorage.getItem('isAuthorizationInProgress') === 'true')

    useEffect(() => {
        if (signingIn) setEngaged(true)
    }, [signingIn])

    useEffect(() => {
        if (allDone) setFinished(true)
    }, [allDone])

    if (!engaged || finished || waitingForUser) return null

    return (
        // The gate is outside of the `.app` element that carries the theme: it brings the class of the theme itself
        <div className={`-${isDarkTheme ? 'dark' : 'light'}-mode`}>
            <div className="startup-gate" role="status">
                <StartupScreen title={t('login:title')} subtitle={t('login:text')} video={isDarkTheme ? darkVideo : greyVideo} steps={steps} retryLabel={t('login:startup.retry')} />
            </div>
        </div>
    )
}

export default StartupGate
